import {createGlobalStyle} from 'styled-components';
import {rootElement} from './config';

const Radius = {
    BUTTON: 'var(--radius-button)',
    BLOCK: 'var(--radius-block)',
};

const GlobalRadiuses = createGlobalStyle`
    ${rootElement} {
        --radius-button: 4px;
        --radius-block: 8px;
    }
`;

export {Radius, GlobalRadiuses};
